import { useState } from 'react';
import { useSettings } from '../useSettings';

export const useDevicePolicyHandlers = () => {
  const { policies, setPolicies } = useSettings();
  const [showAdd, setShowAdd] = useState(false);
  const [editPolicy, setEditPolicy] = useState(undefined);

  function handleRemoveClicked(name) {
    setPolicies((currentPolicies) =>
      currentPolicies.filter((value) => value.name !== name),
    );
  }

  function handleEditClicked(policy) {
    setEditPolicy(policy);
    setShowAdd(true);
  }

  function handleHide() {
    setEditPolicy(undefined);
    setShowAdd(false);
  }

  function handleAddClicked() {
    setShowAdd(true);
  }

  function handleAddComplete(
    name,
    ipAddressOrRangeNotation,
    enabled,
    trusted,
    currentPolicy,
  ) {
    const updatePolicies = (currentPolicies) => {
      const otherPolicies = [...currentPolicies].filter((policy) =>
        currentPolicy ? policy.name !== currentPolicy.name : true,
      );
      return [
        ...otherPolicies,
        {
          name,
          ipAddressOrRangeNotation,
          enabled,
          trusted,
        },
      ];
    };

    setPolicies(updatePolicies);
    setEditPolicy(undefined);
    setShowAdd(false);
  }

  return {
    handleRemoveClicked,
    handleEditClicked,
    handleHide,
    handleAddClicked,
    handleAddComplete,
    policies,
    showAdd,
    editPolicy,
  };
};
